<template>
  <vz-toolbar title="К мультизаявке" @click="back" :disabled="orderTotalPriceLoader" />
</template>

<script setup lang="ts">
import VzToolbar from '~/components/ui-kit/vz-toolbar.vue';
import {useOrderStore} from '~/stores/order';
import {storeToRefs} from 'pinia';

const emit = defineEmits(['send-form'])

const {$confirm} = useNuxtApp()
const {multiOrder, orderForm} = useOrderStore()
const {orderTotalPriceLoader} = storeToRefs(useOrderStore())

async function back() {
  const exit = JSON.stringify(multiOrder.selectedRequest) === JSON.stringify(orderForm)
    ? true
    : await $confirm({
      buttonText: 'Выйти',
      cancelText: 'Отменить',
      title: 'Выйти без сохранения?',
      text: 'При переходе к мультизаявке текущие данные по доставке в текущий адрес не сохранятся'
    })
  if (exit) {
    multiOrder.getFromStorage()
    multiOrder.selectedRequestId = 0
  }
}
</script>

